import { ReactNode } from 'react';
import { NormalButton } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Link from 'next/link';

interface FirstPurchaseDealsProps {
  children: ReactNode;
  button: { text: string; landingUrl: string };
  onClickMore: () => void;
  isLazyLoad?: boolean;
}

const buttonWrapperCss = css`
  margin: -12px 16px 0;
`;

export const FirstPurchaseDeals = ({ children, button, onClickMore }: FirstPurchaseDealsProps) => {
  return (
    <ListSection>
      {children}
      <div css={buttonWrapperCss}>
        <Link href={button.landingUrl} passHref legacyBehavior>
          <NormalButton variant='tertiaryGray' fullWidth UNSTABLE_feedback onClick={onClickMore}>
            {button.text}
          </NormalButton>
        </Link>
      </div>
    </ListSection>
  );
};

const ListSection = styled.div`
  padding: 21px 0 20px 0;
  border-top: 8px solid ${vars.v3Color.gray100};
  overflow: hidden;
`;
export const Title = styled.p`
  color: ${vars.v3Color.gray950};
`;

export const SubTitle = styled.p`
  margin-top: 8px;
  color: ${vars.v3Color.gray600};
`;
